import { render, staticRenderFns } from "./MenuTitleBar.vue?vue&type=template&id=380ba384&lang=html"
import script from "./MenuTitleBar.vue?vue&type=script&lang=js"
export * from "./MenuTitleBar.vue?vue&type=script&lang=js"
import style0 from "./MenuTitleBar.vue?vue&type=style&index=0&id=380ba384&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports